import { styled } from "@mui/material/styles";

export const PageTitleContainer = styled("div")(({ theme, $noMargin }) => ({
  marginBottom: $noMargin ? 0 : "30px",
  "& .page-title-icon": {
    display: "flex",
    background: "#01ECFF",
    width: "56px",
    padding: "14px",
    borderRadius: "12px",
    margin: "0 auto 30px auto",
  },
  "& h1": {
    fontWeight: "700",
    fontSize: "clamp(1rem, 1rem + 2vw, 2.4rem)",
    margin: "0px 0 10px 0",
    lineHeight: "1.2",
    letterSpacing: "-0.02em",
    background: "linear-gradient(95deg,#FEFEFE 0%,#D1C7FF 100%)",
    backgroundClip: "text",
    // [theme.breakpoints.up("md")]: {
    //   margin: "20px 0 20px 0",
    // },
    "& span": {
      display: "block",
      fontSize: "16px",
      fontWeight: "normal",
      opacity: ".8",
      marginTop: "10px",
      lineHeight: "1.4",
    },
  },
  "& > span": {
    fontSize: "12px",
    letterSpacing: "0.06em",
    textTransform: "uppercase",
    fontWeight: 500,
    marginBottom: "8px",
    color: "#A87EFF",
    display: "block",
  },
  "& > p": {
    fontSize: "16px",
    color: "#D1C7FF",
    margin: "15px 0 0",
    maxWidth: "720px",
    [theme.breakpoints.up("md")]: {
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
    },
  },
  "& h2": {
    fontWeight: "bold",
    fontSize: "clamp(0.75rem, 0.75rem + 2vw, 1.3rem)",
    margin: "0px 0 8px 0",
    lineHeight: "1.2",
  },
}));
